/** Keep chart x-viewport from extending into future dates. */
export function refreshNoFutureLimit(chart: {
  options: {
    plugins?: { zoom?: { limits?: { x?: { max?: number } } } };
  };
}): void {
  const limitsX = chart.options.plugins?.zoom?.limits?.x;
  if (limitsX) limitsX.max = Date.now();
}

export function clampChartXToPresent(chart: {
  scales: { x: { min: number; max: number } };
  options: {
    scales?: { x?: { min?: number; max?: number } };
    plugins?: { zoom?: { limits?: { x?: { max?: number } } } };
  };
  update: (mode?: string) => void;
}): void {
  refreshNoFutureLimit(chart);
  const now = Date.now();
  const xScale = chart.scales.x;
  if (!xScale || xScale.max <= now) return;

  const span = xScale.max - xScale.min;
  const scales = chart.options.scales ?? (chart.options.scales = {});
  const xOpts = scales.x ?? (scales.x = {});
  xOpts.max = now;
  xOpts.min = now - span;
  chart.update("none");
}

export function zoomLimitsNoFuture() {
  return {
    x: {
      max: Date.now(),
      minRange: 60 * 1000,
    },
  };
}
